import confetti from "canvas-confetti";

export const celebrate = () =>
  confetti({
    particleCount: 110,
    spread: 75,
    origin: { y: 0.7 },
    colors: ["#FF3B30", "#00B0FF", "#00E676", "#FFD600", "#D500F9", "#FF6D00"],
  });
